import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translate';
import './About.css';

const About = () => {
  const { language } = useLanguage();

  return (
    <div className="about-page">
      {/* 当前位置指示器 */}
      <div className="position">
        <span>{t('about.position', language)}</span>
        <Link to="/">{t('common.daydaygo', language)}</Link>
        <span>{t('common.greaterThan', language)}{t('about.companyInfo', language)}</span>
      </div>

      {/* 主要内容区域 */}
      <div className="about-bg">
        <div className="about-service">
          <p className="txt">
            {t('about.slogan1', language)}
          </p>
          <p className="txt2">
            {t('about.slogan2', language)}
          </p>
        </div>

        <div className="title">
          <p className="name">{t('about.companyOverview', language)}</p>
        </div>

        <table className="about-table">
          <tbody>
            <tr>
              <td className="left">{t('about.companyName', language)}</td>
              <td className="right">{t('about.companyNameValue', language)}</td>
            </tr>
            {/* <tr>
              <td className="left">代表取締役</td>
              <td className="right">薛明健</td>
            </tr> */}
            <tr>
              <td className="left">{t('about.establishment', language)}</td>
              <td className="right">{t('about.establishmentValue', language)}</td>
            </tr>
            <tr>
              <td className="left">{t('about.capital', language)}</td>
              <td className="right">{t('about.capitalValue', language)}</td>
            </tr>
            <tr>
              <td className="left">{t('about.telFax', language)}</td>
              <td className="right">{t('about.telFaxValue', language)}</td>
            </tr>
            <tr>
              <td className="left">{t('about.office', language)}</td>
              <td className="right">{t('about.officeValue', language)}</td>
            </tr>
            <tr>
              <td className="left">{t('about.businessHours', language)}</td>
              <td className="right">{t('about.businessHoursValue', language)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 底部装饰
      <div className="about-bottom">
        <span className="pic">
          <img src="/images/pic-7.png" alt="" />
        </span>
        <span className="txt">See you in Japan!</span>
      </div> */}
    </div>
  );
};

export default About;
